// extracted by mini-css-extract-plugin
export default {"container":"YR-z","modal":"ZR-z","dimensions":"_R-z","brandName":"aS-z","productName":"bS-z","labelValue":"cS-z","recipientEmail":"dS-z","recommendedFit":"eS-z","hiddenField":"fS-z"};